import type { Method } from '../api';

// The server sends no label and no min_confirmations. Build a label from
// what it does send, and fall back to the asset id: ListMethods returns
// only chain_id + asset_id when the operator hardcoded the pair at
// session creation, leaving symbol empty.
function labelFor(m: Method): string {
  return m.symbol ? `${m.symbol} on ${m.chain_id}` : `${m.asset_id} on ${m.chain_id}`;
}

interface MethodPickerProps {
  methods: Method[];
  onSelect: (method: Method) => void;
  disabled?: boolean;
}

export default function MethodPicker({
  methods,
  onSelect,
  disabled,
}: MethodPickerProps) {
  if (methods.length === 0) {
    return (
      <p className="error">
        No payment methods available. Please contact support.
      </p>
    );
  }

  return (
    <div className="card">
      <h2 className="heading">Select payment method</h2>
      <p className="subheading">
        Choose the chain and asset you want to pay with.
      </p>
      <ul className="method-list">
        {methods.map((m) => (
          <li key={`${m.chain_id}:${m.asset_id}`}>
            <button
              type="button"
              className="method"
              disabled={disabled}
              onClick={() => onSelect(m)}
            >
              <span>{labelFor(m)}</span>
              <span className="method-meta">{m.is_token ? 'token' : 'native'}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
